import { apiSlice } from "@/services/api-slice";
import { Category, CreateCategory, UpdateCategory, Subcategory, CreateSubcategory, UpdateSubcategory } from "./categories.interface";
import { APIResponse } from "@/types/custom-http";


export const catalogueApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todas las Categorías
      getCategories: builder.query<APIResponse<Category[]>, void>({
        query: () => ({
          url: "auth/warehouse/catalogue/category"
        }),
        providesTags: ["Catalogue"],
      }),

      
      // Obtener una Categoría por ID
      getCategoryById: builder.query<APIResponse<Category>, number>({
        query: (id) => ({ url:`/warehouse/catalogue/category/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Catalogue', id }],
      }),
      
      // Crear una nueva Categoría
      createCategory: builder.mutation<APIResponse<Category>, CreateCategory>({
        query: (user) => ({
          url: 'auth/warehouse/catalogue/category',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Catalogue'],
      }),
      
      // Actualizar una Categoría existente
      updateCategory: builder.mutation<APIResponse<Category>, { id: number; changes: UpdateCategory }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/catalogue/category/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'Catalogue', id },'Catalogue'],
      }),
      
      // Eliminar una Categoría
      deleteCategory: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/catalogue/category/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Catalogue'],
      }),

      // Obtener todas las Subcategorías
      getSubcategories: builder.query<APIResponse<Subcategory[]>, void>({
        query: () => ({
          url: "auth/warehouse/catalogue/subcategory"
        }),
        providesTags: ["Catalogue"],
      }),

      
      // Obtener una Subcategoría por ID
      getSubcategoryById: builder.query<APIResponse<Subcategory>, number>({
        query: (id) => ({ url:`auth/warehouse/catalogue/subcategory/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Catalogue', id }],
      }),

      // Obtener una Subcategoría por ID
      getSubcategoryByCategoryId: builder.query<APIResponse<Subcategory[]>, number>({
        query: (id) => ({ url:`auth/warehouse/catalogue/subcategory/category/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Catalogue', id }],
      }),

      
      // Crear una nueva Subcategoría
      createSubcategory: builder.mutation<APIResponse<Subcategory>, CreateSubcategory>({
        query: (user) => ({
          url: 'auth/warehouse/catalogue/subcategory',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Catalogue'],
      }),
      
      // Actualizar una Subcategoría existente
      updateSubcategory: builder.mutation<APIResponse<Subcategory>, { id: number; changes: UpdateSubcategory }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/catalogue/subcategory/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'Catalogue', id },'Catalogue'],
      }),
      
      // Eliminar una Subcategoría
      deleteSubcategory: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/catalogue/subcategory/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Catalogue'],
      })

    }),
  });
  
  export const {
    useGetCategoriesQuery,
    useGetCategoryByIdQuery,
    useUpdateCategoryMutation,
    useCreateCategoryMutation,
    useDeleteCategoryMutation,
    useGetSubcategoriesQuery,
    useGetSubcategoryByIdQuery,
    useGetSubcategoryByCategoryIdQuery,
    useLazyGetSubcategoryByCategoryIdQuery,
    useCreateSubcategoryMutation,
    useUpdateSubcategoryMutation,
    useDeleteSubcategoryMutation
  } = catalogueApi;